import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Logo } from "@/components/site/Logo";
import { api } from "@/lib/site";
import { inp } from "./ui";
import { PropertiesAdmin } from "./PropertiesAdmin";
import { CountriesAdmin } from "./CountriesAdmin";
import { SettingsAdmin, InquiriesAdmin, FeedAdmin } from "./SettingsAdmin";
import { ImportAdmin } from "./ImportAdmin";
import { ContentAdmin } from "./ContentAdmin";
import { BlogAdmin } from "./BlogAdmin";

const Login = ({ onOk }) => {
  const [f, setF] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const r = await api.post("/auth/login", f);
      localStorage.setItem("mx_token", r.data.token);
      onOk();
    } catch (x) {
      const d = x.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Prihlásenie zlyhalo");
    }
  };
  return (
    <main className="min-h-screen bg-midnight flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-ivory p-10 space-y-5">
        <div className="text-center mb-6"><Logo light={false} /></div>
        <input className={inp} placeholder="Používateľ" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} data-testid="admin-username" />
        <input className={inp} type="password" placeholder="Heslo" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-password" />
        {err && <p className="text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
        <button className="btn-gold w-full h-12" data-testid="admin-login-submit">Prihlásiť</button>
      </form>
    </main>
  );
};

export default function Admin() {
  const [auth, setAuth] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem("mx_token")) { setAuth(false); return; }
    api.get("/auth/me").then(() => setAuth(true)).catch(() => { localStorage.removeItem("mx_token"); setAuth(false); });
  }, []);
  if (auth === null) return <main className="min-h-screen bg-midnight" />;
  if (!auth) return <Login onOk={() => setAuth(true)} />;
  const tab = "rounded-none data-[state=active]:bg-midnight data-[state=active]:text-ivory text-xs tracking-[0.15em] uppercase px-4";
  return (
    <main className="min-h-screen bg-[#F3EFE7]" data-testid="admin-page">
      <header className="bg-midnight px-6 py-4 flex items-center justify-between">
        <Link to="/"><Logo size="sm" /></Link>
        <button onClick={() => { localStorage.removeItem("mx_token"); setAuth(false); }} className="text-ivory/80 hover:text-gold flex items-center gap-2 text-xs tracking-[0.2em] uppercase" data-testid="admin-logout"><LogOut size={14} /> Odhlásiť</button>
      </header>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <Tabs defaultValue="properties">
          <TabsList className="bg-white rounded-none h-auto flex-wrap justify-start mb-8">
            <TabsTrigger value="properties" className={tab} data-testid="tab-properties">Nehnuteľnosti</TabsTrigger>
            <TabsTrigger value="blog" className={tab} data-testid="tab-blog">Blog</TabsTrigger>
            <TabsTrigger value="content" className={tab} data-testid="tab-content">Obsah webu</TabsTrigger>
            <TabsTrigger value="countries" className={tab} data-testid="tab-countries">Krajiny a kraje</TabsTrigger>
            <TabsTrigger value="settings" className={tab} data-testid="tab-settings">Pätička a texty</TabsTrigger>
            <TabsTrigger value="inquiries" className={tab} data-testid="tab-inquiries">Dopyty</TabsTrigger>
            <TabsTrigger value="feed" className={tab} data-testid="tab-feed">Export feed</TabsTrigger>
            <TabsTrigger value="import" className={tab} data-testid="tab-import">Import feed</TabsTrigger>
          </TabsList>
          <TabsContent value="properties"><PropertiesAdmin /></TabsContent>
          <TabsContent value="blog"><BlogAdmin /></TabsContent>
          <TabsContent value="content"><ContentAdmin /></TabsContent>
          <TabsContent value="countries"><CountriesAdmin /></TabsContent>
          <TabsContent value="settings"><SettingsAdmin /></TabsContent>
          <TabsContent value="inquiries"><InquiriesAdmin /></TabsContent>
          <TabsContent value="feed"><FeedAdmin /></TabsContent>
          <TabsContent value="import"><ImportAdmin /></TabsContent>
        </Tabs>
      </div>
    </main>
  );
}
